import { render } from "./SearchHistory.vue?vue&type=template&id=8ff34800"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"

import "./SearchHistory.vue?vue&type=style&index=0&id=8ff34800&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__